export const DOCUMENT_TYPES = [
  {
    key: 'national-id',
    name: 'Cédula de ciudadanía'
  },
  {
    key: 'foreign-id',
    name: 'Cédula de extranjería'
  },
  {
    key: 'passport',
    name: 'Pasaporte'
  }
]
